import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { DashboardFilters } from "../DashboardFilters/DashboardFilters";
import { DashboardPersonalFilters } from "../DashboardPersonalFilters/DashboardPersonalFilters";
import { ACTVerDispositivos } from "./ACTVerDispositivos";
import { ACTVerHistorialCheckin } from "./ACTVerHistorialCheckin";
import { ACTVerHistorialCheckinVerUbicacion } from "./ACTVerHistorialCheckinVerUbicacion";
import { ACTVerHistorialUbicacion } from "./ACTVerHistorialUbicacion";
import { ACTVerHistorialVerUbicacion } from "./ACTVerHistorialVerUbicacion";
import { ACTVerLogins } from "./ACTVerLogins";
import { ACTVerPersonalTienda } from "./ACTVerPersonalTienda";
import { ACTVerReportes } from "./ACTVerReportes";
import { ACTVerReportesPersonal } from "./ACTVerReportesPersonal";
import { ACTVerReportesTienda } from "./ACTVerReportesTienda";
import { ACTVerRutasEnTiendaDashboard } from "./ACTVerRutasEnTiendaDashboard";
import { ACTVerUbicacionDashboard } from "./ACTVerUbicacionDashboard";
import { ACTVerVersionesApp } from "./ACTVerVersionesApp";
import { ACTVerVisitas } from "./ACTVerVisitas";
import { CheckinVisitasPersonalViewInfoWindowRenderer } from "./CheckinVisitasPersonalViewInfoWindowRenderer";
import { CheckinVisitasPersonalViewMarkerRenderer } from "./CheckinVisitasPersonalViewMarkerRenderer";
import { CheckoutVisitasPersonalViewInfoWindowRenderer } from "./CheckoutVisitasPersonalViewInfoWindowRenderer";
import { CheckoutVisitasPersonalViewMarkerRenderer } from "./CheckoutVisitasPersonalViewMarkerRenderer";
import { HistorialCheckinVerUbicacionTiendaViewMarkerRenderer } from "./HistorialCheckinVerUbicacionTiendaViewMarkerRenderer";
import { HistorialCheckinVerUbicacionViewMarkerRenderer } from "./HistorialCheckinVerUbicacionViewMarkerRenderer";
import { PersonalHistorialCheckinViewColumnsOverrides } from "./PersonalHistorialCheckinViewColumnsOverrides";
import { PersonalLocalizacionViewInfoWindowRenderer } from "./PersonalLocalizacionViewInfoWindowRenderer";
import { PersonalLocalizacionViewMarkerRenderer } from "./PersonalLocalizacionViewMarkerRenderer";
import { TiendasViewInfoWindowRenderer } from "./TiendasViewInfoWindowRenderer";
import { TiendasViewMarkerRenderer } from "./TiendasViewMarkerRenderer";
import { TiendasVisitasPersonalViewColumnsOverrides } from "./TiendasVisitasPersonalViewColumnsOverrides";
import { TiendasVisitasPersonalViewMarkerRenderer } from "./TiendasVisitasPersonalViewMarkerRenderer";
import { UbicacionPersonalViewMarkerRenderer } from "./UbicacionPersonalViewMarkerRenderer";

const columns = () =>
(
    {
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Personal Id' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Tienda Id' }),
        i_autorizaciones: new EntityColumn<number>({ name: 'i_autorizaciones', type: 'int', flags: c.Edit, prompt: 'Autorizaciones' }),
        i_autorizaciones_total: new EntityColumn<number>({ name: 'i_autorizaciones_total', type: 'int', flags: c.Edit, prompt: 'Total' }),
        i_personal_presentes: new EntityColumn<number>({ name: 'i_personal_presentes', type: 'int', flags: c.Edit, prompt: 'Presentes' }),
        i_personal_ausentes: new EntityColumn<number>({ name: 'i_personal_ausentes', type: 'int', flags: c.Edit, prompt: 'Ausentes' }),
        i_personal_sin_reportar: new EntityColumn<number>({ name: 'i_personal_sin_reportar', type: 'int', flags: c.Edit, prompt: 'Sin Reportar' }),
        i_personal_total: new EntityColumn<number>({ name: 'i_personal_total', type: 'int', flags: c.Edit, prompt: 'Total' }),
        i_visitas_finalizadas: new EntityColumn<number>({ name: 'i_visitas_finalizadas', type: 'int', flags: c.Edit, prompt: 'Finalizadas' }),
        i_visitas_en_proceso: new EntityColumn<number>({ name: 'i_visitas_en_proceso', type: 'int', flags: c.Edit, prompt: 'En Proceso' }),
        i_visitas_sin_iniciar: new EntityColumn<number>({ name: 'i_visitas_sin_iniciar', type: 'int', flags: c.Edit, prompt: 'Sin Iniciar' }),
        i_visitas_total: new EntityColumn<number>({ name: 'i_visitas_total', type: 'int', flags: c.Edit, prompt: 'Total' }),
        i_total_personal_checkin: new EntityColumn<number>({ name: 'i_total_personal_checkin', type: 'int', flags: c.Edit, prompt: 'Personal Checkin' }),
        i_total_personal_sin_checkin: new EntityColumn<number>({ name: 'i_total_personal_sin_checkin', type: 'int', flags: c.Edit, prompt: 'Personal Sin Checkin' }),
        c_datos_geolocation_id: new EntityColumn<string>({ name: 'c_datos_geolocation_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Geolocalización Id' }),
        c_personal_filtro_id: new EntityColumn<string>({ name: 'c_personal_filtro_id', type: 'char', length: 20, flags: c.FK, prompt: 'Personal Filtro Id' }),
        c_datos_checkin_id: new EntityColumn<string>({ name: 'c_datos_checkin_id', type: 'char', length: 20, flags: c.FK, prompt: 'Datos Chekin Id' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        dash_brwStandard: { name: 'dash_brwStandard', keyMappings: {} },
        dash_brwPersonalLocalizacion: {
            name: 'dash_brwPersonalLocalizacion', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DashboardFilters(client, parentKeys),
            mapMarkerRenderer: PersonalLocalizacionViewMarkerRenderer,
            mapInfoWindowRenderer: PersonalLocalizacionViewInfoWindowRenderer
        },
        dash_brwPersonalLocalizacionPresentes: {
            name: 'dash_brwPersonalLocalizacionPresentes', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DashboardPersonalFilters(client, parentKeys),
        },
        dash_brwPersonalLocalizacionAusentes: {
            name: 'dash_brwPersonalLocalizacionAusentes', keyMappings: { c_personal_id: 0 },
             FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DashboardPersonalFilters(client, parentKeys),
        },
        dash_brwPersonalLocalizacionSinReportar: {
            name: 'dash_brwPersonalLocalizacionSinReportar', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DashboardPersonalFilters(client, parentKeys),
        },
        dash_brwTiendas: {
            name: 'dash_brwTiendas', keyMappings: { c_tienda_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DashboardFilters(client, parentKeys),
            mapMarkerRenderer: TiendasViewMarkerRenderer,
            mapInfoWindowRenderer: TiendasViewInfoWindowRenderer
        },
        dash_brwTiendasPersonal: { name: 'dash_brwTiendasPersonal', keyMappings: { c_tienda_id: 0 } },
        dash_brwUbicacionPersonal: {
            name: 'dash_brwUbicacionPersonal', keyMappings: { c_personal_id: 0 },
            mapMarkerRenderer: UbicacionPersonalViewMarkerRenderer
        },
        dash_brwTiendasVisitasPersonal: {
            name: 'dash_brwTiendasVisitasPersonal', keyMappings: { c_tienda_id: 0 },
            gridColumnsOverrides: TiendasVisitasPersonalViewColumnsOverrides,
            mapMarkerRenderer: TiendasVisitasPersonalViewMarkerRenderer
        },
        dash_brwCheckinVisitasPersonal: {
            name: 'dash_brwCheckinVisitasPersonal', keyMappings: { c_tienda_id: 0 },
            mapMarkerRenderer: CheckinVisitasPersonalViewMarkerRenderer,
            mapInfoWindowRenderer: CheckinVisitasPersonalViewInfoWindowRenderer
        },
        dash_brwCheckoutVisitasPersonal: {
            name: 'dash_brwCheckoutVisitasPersonal', keyMappings: { c_tienda_id: 0 },
            mapMarkerRenderer: CheckoutVisitasPersonalViewMarkerRenderer,
            mapInfoWindowRenderer: CheckoutVisitasPersonalViewInfoWindowRenderer
        },
        dash_brwPersonalSinCheckin: {
            name: 'dash_brwPersonalSinCheckin', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DashboardPersonalFilters(client, parentKeys),
        },
        dash_brwPersonalSinCheckinSupervisor: {
            name: 'dash_brwPersonalSinCheckinSupervisor', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DashboardPersonalFilters(client, parentKeys),
        },
        dash_brwPersonalHistorialUbicaciones: { name: 'dash_brwPersonalHistorialUbicaciones', keyMappings: { c_datos_geolocation_id: 3 } },
        dash_brwPersonalHistorialVerUbicacion: { name: 'dash_brwPersonalHistorialVerUbicacion', keyMappings: { c_datos_geolocation_id: 3 } },
        dash_brwPersonalDispositivos: { name: 'dash_brwPersonalDispositivos', keyMappings: {} },
        dash_brwPersonalLogins: { name: 'dash_brwPersonalLogins', keyMappings: {} },
        dash_brwPersonalVersionesApp: { name: 'dash_brwPersonalVersionesApp', keyMappings: {} },
        dash_brwPersonalHistorialCheckin: {
            name: 'dash_brwPersonalHistorialCheckin', keyMappings: { c_datos_checkin_id: 13 },
            gridColumnsOverrides: PersonalHistorialCheckinViewColumnsOverrides
        },
        dash_brwPersonalHistorialCheckinVerUbicacion: {
            name: 'dash_brwPersonalHistorialCheckinVerUbicacion', keyMappings: { c_datos_checkin_id: 10 },
            mapMarkerRenderer: HistorialCheckinVerUbicacionViewMarkerRenderer,
        },
        dash_brwPersonalHistorialCheckinVerUbicacionTienda: {
            name: 'dash_brwPersonalHistorialCheckinVerUbicacionTienda', keyMappings: { c_datos_checkin_id: 13 },
            mapMarkerRenderer: HistorialCheckinVerUbicacionTiendaViewMarkerRenderer,
        },
    }
)

const procs = () =>
(
    {
        dash_getUbicacionPersonal: { name: 'dash_getUbicacionPersonal' }
    }
)

const clientActions = () =>
(
    {
        ACTVerReportesPersonal: ACTVerReportesPersonal,
        ACTVerReportesTienda: ACTVerReportesTienda,
        ACTVerPersonalTienda: ACTVerPersonalTienda,
        ACTVerRutasEnTiendaDashboard: ACTVerRutasEnTiendaDashboard,
        ACTVerUbicacionDashboard: ACTVerUbicacionDashboard,
        ACTVerHistorialUbicacion: ACTVerHistorialUbicacion,
        ACTVerHistorialVerUbicacion: ACTVerHistorialVerUbicacion,
        ACTVerDispositivos: ACTVerDispositivos,
        ACTVerLogins: ACTVerLogins,
        ACTVerReportes: ACTVerReportes,
        ACTVerVersionesApp: ACTVerVersionesApp,
        ACTVerHistorialCheckin: ACTVerHistorialCheckin,
        ACTVerHistorialCheckinVerUbicacion: ACTVerHistorialCheckinVerUbicacion,
        ACTVerVisitas: ACTVerVisitas
    }
)

export class DashboardDef extends EntityDefinition {

    columns = columns();
    views = views();
    procs = procs();
    clientActions = clientActions();

    constructor() {
        super('Dashboard');
    }
}